module.exports = __webpack_public_path__ + "assets/img/11523db777dedb2d4b0a4254061f0903.svg";